import { useAuth } from "src/providers/AuthProvider";

const hasPermission = (userPermissions, permission) => userPermissions?.includes(permission) ?? false;

const isAndPermission = (permissionToCheck) => typeof permissionToCheck.at(0) === "string";

const useHasPermissions = (permissionToCheck) => {
	const { user } = useAuth();
	const userPermissions = user?.permissions ?? [];

	return checkPermission(permissionToCheck, userPermissions);
};

export const checkPermission = (permissionToCheck, userPermissions) => {
	if (!permissionToCheck) return true;

	if (typeof permissionToCheck === "string") return hasPermission(userPermissions, permissionToCheck);

	if (isAndPermission(permissionToCheck)) return permissionToCheck.every((permission) => hasPermission(userPermissions, permission));

	return permissionToCheck.some((permissionGroup) => permissionGroup.every((permission) => hasPermission(userPermissions, permission)));
};

export default useHasPermissions;
